riot.tag2('gb-refinement-crumb', '<a onclick="{remove}">&times;</a> <b>{nav.displayName}: {_scope.toView(ref)}</b>', '', '', function(opts) {
    this.remove = () => this._scope.remove(opts.ref, opts.nav);
    this.nav = opts.nav;
    this.ref = opts.ref;
});



/** WEBPACK FOOTER **
 ** ./src/tags/breadcrumbs/gb-refinement-crumb.tag.html
 **/